var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.hasHours
    ? _c(
        "div",
        { staticClass: "hours-block" },
        [
          _c("div", { staticClass: "hours-heading__row" }, [
            _c("div", { staticClass: "hours-heading" }, [
              _c("h3", { staticClass: "heading" }, [
                _vm._v(_vm._s(_vm.heading))
              ]),
              _vm._v(" "),
              !_vm.hours.overrideText
                ? _c(
                    "button",
                    {
                      staticClass: "now hasPointer",
                      attrs: {
                        tabindex: "0",
                        "aria-controls": _vm.idcontrol + "-" + _vm.heading,
                        "aria-expanded": _vm.expanded ? "true" : "false"
                      },
                      on: {
                        click: function($event) {
                          _vm.expanded = !_vm.expanded
                        }
                      }
                    },
                    [
                      !_vm.hours.overrideText
                        ? _c("div", { staticClass: "now" }, [
                            _vm.listViewContext.hours === "Closed"
                              ? _c("span", [
                                  _vm._v(
                                    "\n                        " +
                                      _vm._s(_vm.listViewContext.dow) +
                                      " "
                                  ),
                                  _c("span", { staticClass: "closed-now" }, [
                                    _vm._v(_vm._s(_vm.listViewContext.hours))
                                  ])
                                ])
                              : _c("span", [
                                  _vm.openNow
                                    ? _c("span", { staticClass: "open-now" }, [
                                        _vm._v("Open Now")
                                      ])
                                    : _c(
                                        "span",
                                        { staticClass: "closed-now" },
                                        [_vm._v("Closed Now")]
                                      ),
                                  _vm._v(
                                    " | \n                        " +
                                      _vm._s(_vm.listViewContext.hours) +
                                      "\n                    "
                                  )
                                ])
                          ])
                        : _vm._e()
                    ]
                  )
                : _vm._e()
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "hours-button" }, [
              _c(
                "button",
                {
                  class: { "pill large": true },
                  attrs: {
                    type: "button",
                    "aria-controls": _vm.idcontrol + "-" + _vm.heading,
                    "aria-expanded": _vm.expanded ? "true" : "false"
                  },
                  on: {
                    click: function($event) {
                      _vm.expanded = !_vm.expanded
                    }
                  }
                },
                [
                  _c("span", { staticClass: "sr-only" }, [_vm._v("Show ")]),
                  _vm._v(
                    _vm._s(_vm.expanded ? "Less Hours" : "More Hours") +
                      "\n                "
                  ),
                  _c("span", { class: { caret: true, expanded: _vm.expanded } })
                ]
              )
            ])
          ]),
          _vm._v(" "),
          !_vm.hours.overrideText
            ? _c("transition", { attrs: { name: "slide" } }, [
                _vm.expanded
                  ? _c(
                      "ul",
                      {
                        staticClass: "details",
                        attrs: { id: _vm.idcontrol + "-" + _vm.heading }
                      },
                      _vm._l(_vm.daysOfWeek, function(dow) {
                        return _c("li", { key: dow.day }, [
                          _c("span", { staticClass: "day" }, [
                            _vm._v(_vm._s(dow.abbreviation))
                          ]),
                          _c("span", { staticClass: "time" }, [
                            _vm._v(_vm._s(_vm.timeFormat(_vm.hours[dow.day])))
                          ])
                        ])
                      }),
                      0
                    )
                  : _vm._e()
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.hours.overrideText
            ? _c("span", {
                domProps: { innerHTML: _vm._s(_vm.hours.overrideText) }
              })
            : _vm._e()
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }